import { render, staticRenderFns } from "./ApplicantStudentPriorityOrder.vue?vue&type=template&id=95e0b5fa&"
import script from "./ApplicantStudentPriorityOrder.vue?vue&type=script&lang=js&"
export * from "./ApplicantStudentPriorityOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports